<template>
<section class="section reference"
  :class="{'pretty-top' : (!hasAnyStatusTabSections && toShowOverviewTab) &&  currentTab === 'alberta' || !state.isSpecies,
    'bgLight': !state.isSpecies}">

  <div class="container">
    <h2>{{ $t('profile.referenceSection.title') }}</h2>
    <div class="columns">
      <div class="column is-6-desktop is-6-tablet" v-if="hasLeftColumn">
        <div v-if="sppContent?.WebReference">
          <h4>{{ $t('profile.referenceSection.reference.title') }}</h4>
          <div class="auto  WebReference" v-html="sppContent?.WebReference"></div>
        </div>
        <div v-if="conservationReferenceHtml.length > 0">
          <h4>{{ $t('profile.referenceSection.reference.conservationStatus.title') }}</h4>
          <template v-for="(single, index) in conservationReferenceHtml" :key="'conservationRef' + index">
            <div class="profile" v-html="single">
            </div>
          </template>
        </div>
      </div>
      <div class="column" :class="{'is-6-desktop is-6-tablet': hasLeftColumn, 'is-12-desktop is-12-tablet': !hasLeftColumn}">
        <h4>{{ $t('profile.referenceSection.citation.title') }}</h4>
        <div id="citation"
          v-html="$t('profile.referenceSection.citation.content', {birdContent: state.isBird ? birdContent: '', url: getProfileUrl(state, state?.groupName), citationYear: state.sppGroup?.releaseYear, sppFullName: getCombinedDisplaySpeciesName(state)})" />

        <!-- data source-->
        <h4>{{ $t('profile.referenceSection.source.title') }}</h4>
        <template v-if="state.isBird"><div v-html="$t('profile.referenceSection.source.groupBird')" /></template>
        <template v-else><div v-html="$t('profile.referenceSection.source.groupOther')" /></template>

        <!-- additional resouce-->
        <h4>{{ $t('profile.referenceSection.resource.title') }}</h4>
        <div id="citation" v-html="$t('profile.referenceSection.resource.content')" />
        <!-- content update -->
        <template v-if="sppContent.UpdatedBy">
          <h4>{{ $t('profile.referenceSection.content.title') }}</h4>
          <div> {{ sppContent.UpdatedBy }}</div>
        </template>
        <!-- Photo Credit -->
        <h4>{{ $t('profile.referenceSection.photo.title') }}</h4>
        <template v-if="sppContent?.photoCredits != null && Object.keys(sppContent?.photoCredits)?.length > 0">
          <template v-for="(item, key, index) in sppContent.photoCredits" :key="key">
            <template v-if="item.length > 0" >
              <span class="bold">{{  $t('profile.referenceSection.photo.category.' + key) }}</span>: <span v-html="item.join(', ')"></span>
              <template v-if="index < Object.keys(sppContent.photoCredits).length - 1 "> | </template>
            </template>
          </template>
        </template>
        <template v-else><div v-html="$t('profile.referenceSection.photo.placeHolder')" /></template>
      </div>
    </div>
  </div>
</section>

</template>

<script setup>
import { computed } from 'vue';
import { useApp } from '@/composables/state/profileState';
import { useI18n } from 'vue-i18n';
import { getCombinedDisplaySpeciesName } from '@/config/profile-config.js';
import { getProfileUrl } from '../../config/profile-config';

const { tm } = useI18n();
const { state, conservationReference, sppContent, currentTab, toShowOverviewTab, hasAnyStatusTabSections } = useApp();
const birdContent = tm('profile.referenceSection.citation.birdContent');

const conservationReferenceHtml = computed(() => {
  const list = [];
  conservationReference.forEach(single => {
    list.push(tm('profile.referenceSection.reference.conservationStatus.' + single))
  });
  list.sort();
  return list;
});

const hasLeftColumn = computed(() => {
  return sppContent?.WebReference || conservationReferenceHtml.length > 0;
})
</script>
<style scoped>
h4 {
  margin-bottom: 5px;
}
h2 {
  margin-bottom: 1em;
}
.reference {
  padding-top: 50px;
}

</style>

<style>
.section.reference a {
    word-break: break-word;
}

.auto.WebReference p a {
  color: #a7b452 !important;
  text-decoration: none !important;
}
</style>
